import { render } from "./Granerror.vue?vue&type=template&id=6c12e153&scoped=true"
const script = {}

import "./Granerror.vue?vue&type=style&index=0&id=6c12e153&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c12e153"]])

export default __exports__